$(function() {
    //favorite__heart {
    $('.favorite__heart').on({'click':function(){
		$(this).parent('.favorite').toggleClass('active');
		return false;
		}
	});
    //reviews
    $('.productDetail__contents--aside.reviews .plus').on({'click':function(){
		$(this).parent('.productDetail__contents--aside').toggleClass('selected');
		$(this).next('.reviews__contetns').slideToggle(300);
		return false;
		}
	});
    //brandTop product__list
    var count = 1;
    $('.brandTop .btn--text > p').on({'click':function(){
      for(var i = count * 12; i < (count + 1) * 12; i++) {
        $('.brandTop .articleSticky .articleSticky--right .product__list > li:eq('+ i +')').show();
      }
		count++;
		if(count >= 3)$(this).parent('.btn--text').toggleClass('disable');
		return false;
		}
	});

    var breakW = 1023;
    //sp slick product img
	function setTopSize() {}
	setTopSize.prototype.top = function() {
        var winW = $(window).width();
        setSlick(winW);
	}
	var resize = new setTopSize();
	$(window).resize(function() {
		resize.top();
	});
	resize.top();

	function setSlick(w) {
		if (w <= breakW) {
            $('.productDetail__img').not('.slick-initialized').slick({
                //スライドさせる
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 6000
            });
        } else {
            $('.productDetail__img.slick-initialized').slick('unslick');
        }
	}
  
   if(document.URL.match("/pages/tsl_cub") || document.URL.match("collections/tsl_bag") || document.URL.match("collections/tools") || document.URL.match("collections/furniture") || document.URL.match("collections/tsl_other")) {
		$('.products__stickyNav--list > li:eq(1) dt').addClass('selected');
		$('.products__stickyNav--list > li:eq(1) dd').show();
		
	} else if(document.URL.match("collections/sample-sale") || document.URL.match("collections/bag-sample-sale") || document.URL.match("collections/leather-sample-sale") || document.URL.match("collections/clothing-sample-sale") || document.URL.match("collections/other-sample-sale")) {
		$('.products__stickyNav--list > li:eq(2) dt').addClass('selected');
		$('.products__stickyNav--list > li:eq(2) dd').show();
		
	} else if(document.URL.match("/pages/the_superior_labor") || document.URL.match("collections/bag") || document.URL.match("collections/wallet") || document.URL.match("collections/stationery") || document.URL.match("collections/accessory") || document.URL.match("collections/other") || document.URL.match("collections/leather")) {
		$('.products__stickyNav--list > li:eq(0) dt').addClass('selected');
		$('.products__stickyNav--list > li:eq(0) dd').show();
		
		//if(document.URL.match("collections/bag")) $('.products__stickyNav--list > li:eq(0) ul > li:eq(0)').addClass('selected');
	}
  	function getParam() {
        var url   = location.href;
        parameters    = url.split("?");
		if(parameters.length === 1) return false;
        params   = parameters[1].split("&");
        var paramsArray = [];
        for ( i = 0; i < params.length; i++ ) {
            neet = params[i].split("=");
            paramsArray.push(neet[0]);
            paramsArray[neet[0]] = neet[1];
        }
        var categoryKey = paramsArray["page"];
        return categoryKey;
	}
	
	if(getParam()) {
		setTimeout(function() {
			var target = $( '.contentsKv__img' ).height() + 115;
			if( $(window ).width() <= 768 ) target = $( '.contentsKv__img' ).height();
			gsap.to(window, .8, { scrollTo: target, ease: Power4.easeInOut});
			console.log(target)
		},400);
		
	}
});
